import { ChangeEvent, useState } from 'react';
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { DropdownListViewModel } from '../../types/dropdownList';
import JabraLegend from '../Shared/JabraLegend';
import JabraSelect from '../Shared/JabraSelect';

const DropdownList: React.FC<ListFieldProps<DropdownListViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const {
    dictionaryLabel,
    items,
    labelCssClass,
    labelOption,
    required,
    showEmptyItem,
    showLegend,
    title,
  } = field.model;
  const [value, setValue] = useState(props.value[0]);
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      {!!Label && <Label {...props} />}
      <JabraSelect
        id={id}
        name={name}
        value={value}
        jssMetadata={props}
        required={required}
        onChange={onChange}
      >
        {showEmptyItem && <option value="">{!!labelOption ? labelOption : dictionaryLabel}</option>}
        {items.map(({ itemId, value, text }) => (
          <option key={itemId} value={value}>
            {text}
          </option>
        ))}
      </JabraSelect>
      {showLegend && !!title && (
        <JabraLegend className={labelCssClass} dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default DropdownList;
